/* Points <-> Pesos conversion (1:1 by default; overridden by API settings) */

let RATE = 1.0; // pesos per point
let PLAYERS_PCT = 0.78; // share of pool that goes to winners
let PLATFORM_PCT = 0.15;
let CREATOR_PCT = 0.05;
let LEAGUE_PCT = 0.02;

export function setPointToPesoRate(rate) {
    if (typeof rate === "number" && rate > 0) RATE = rate;
}

export function applyPublicSettings(s) {
    if (!s) return;
    if (typeof s.point_to_peso_rate === "number" && s.point_to_peso_rate > 0) RATE = s.point_to_peso_rate;
    if (typeof s.players_pct === "number") PLAYERS_PCT = s.players_pct;
    if (typeof s.platform_pct === "number") PLATFORM_PCT = s.platform_pct;
    if (typeof s.creator_pct === "number") CREATOR_PCT = s.creator_pct;
    if (typeof s.league_pct === "number") LEAGUE_PCT = s.league_pct;
}

export function getPointToPesoRate() {
    return RATE;
}

export function getPlayersPct() {
    return PLAYERS_PCT;
}

export function getSettlementPcts() {
    return { players: PLAYERS_PCT, platform: PLATFORM_PCT, creator: CREATOR_PCT, league: LEAGUE_PCT };
}

export function pointsToPesos(points) {
    if (!Number.isFinite(Number(points))) return 0;
    return Number(points) * RATE;
}

export function formatPesos(points) {
    const value = pointsToPesos(points);
    return "$" + new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(Math.round(value));
}
